import { op } from "@chromia/ft4";

import { store } from "../../store/store";
import { eModalsActionTypes } from "../../store/modals/modalsTypes";
import { fTokenIds, itemIds } from "../../settings";
import { getAssetBallanceQuery } from "./queries";
import { logErrorKas } from "../helpers";

/* export const SetCreator = async () => {
	const { session } = store.getState().chromia;

	if (!session) throw new Error('');

	const recipe = await session.call(op(
		'SetItemCreator',
		Buffer.from('808bb14a9f40e9c21c1769a713fd114e9a127925d8037abfefd8788c20a147f3', 'hex')	// 7795 don't forget to change
	))
	console.log('SetItemCreator: ', recipe);
} */

export const CreateItem = async (
	ftAddress: string,
	utAddress: string,
	pricePoolAddress: string,
	discountPercent: string,	// number
) => {
	const { session } = store.getState().chromia;

	if (!session) throw new Error('');

	const recipe = await session.call(op(
		'pickaxe.Create',
		Buffer.from(ftAddress, 'hex'),
		Buffer.from(utAddress, 'hex'),
		Buffer.from(pricePoolAddress, 'hex'),
		discountPercent,
	))
	console.log('pickaxe.Create: ', recipe);
}

/* interface iNewPeriodArgs {
	ordRefPrice: string,	// number
} */
export const NewPeriod = async (
	// ...args: iNewPeriodArgs
	orderRefPrice: string,	// number
	orderDelta: string,	// number
	orderPrice: string,	// number
	orderMinPrice: string, // number
) => {
	const { discountPercent } = store.getState().app;
	const { session } = store.getState().chromia;

	if (!session) throw new Error('');

	const recipe = await session.call(op(
		'pickaxe.NewPeriod',
		Buffer.from(itemIds[discountPercent], 'hex'),
		orderRefPrice,
		orderDelta,
		orderPrice,
		orderMinPrice,
	))
	console.log('pickaxe.NewPeriod: ', recipe);
}

/* export const ChangeOrder = async (
	// ...args: iNewPeriodArgs
	orderRefPrice: string,	// number
	orderDelta: string,	// number
	orderPrice: string,	// number
	orderMinPrice: string, // number
) => {
	const { session } = store.getState().chromia;

	if (!session) throw new Error('');

	const recipe = await session.call(op(
		'pickaxe.ChangeOrder',
		orderRefPrice,
		orderDelta,
		orderPrice,
		orderMinPrice,
	))
	console.log('pickaxe.ChangeOrder: ', recipe);
} */

export const EndPeriod = async () => {
	const { discountPercent } = store.getState().app;
	const { session } = store.getState().chromia;

	if (!session) throw new Error('');

	const recipe = await session.call(op(
		'pickaxe.EndPeriod',
		Buffer.from(itemIds[discountPercent], 'hex')
	))
	console.log('pickaxe.EndPeriod: ', recipe);
}

export const Deposit = async (
	depositAmount: string,	// number
) => {
	const { discountPercent } = store.getState().app;
	const { session } = store.getState().chromia;

	if (!session) throw new Error('');

	if (depositAmount[depositAmount.length-1] === '.') depositAmount = depositAmount.slice(0, -1);

	const fTokenBalance = await getFTokenBalance();
	if (+fTokenBalance.amount < +depositAmount){
		store.dispatch({
			type: eModalsActionTypes.OPEN_NEW_MODAL,
			payload: {
				name: 'info',
				// title: 'Insufficient ' + fTokenBalance.asset.name + ' balance. Needed: ' + depositAmount + ', in wallet: ' + fTokenBalance.amount,
				message: 'Insufficient ' + fTokenBalance.asset.name + ' balance. Needed: ' + depositAmount + ', in wallet: ' + fTokenBalance.amount,
				type: 'warning'
			}
		})
		throw new Error();
	}

	try {
		const tx = session.call(op(
			'pickaxe.Deposit',
			Buffer.from(itemIds[discountPercent], 'hex'),
			depositAmount
		))

		store.dispatch({
			type: eModalsActionTypes.OPEN_NEW_MODAL,
			payload: {
				name: 'transaction',
				transactionParams: {
					blockchain: 'chromia',
					transaction: tx,
				}
			}
		})

		console.log('tx: ', tx);
		const recipe = await tx;
		console.log('pickaxe.Deposit: ', recipe);
	} catch (err) {
		// console.log('cathed err: ', err);
		logErrorKas(err as any);
		throw err;
	}
}

/* export const Withdraw = async () => {
	const { discountPercent } = store.getState().app;
	const { session, chrClientAddr } = store.getState().chromia;

	if (!session || ! chrClientAddr) throw new Error('');

	const recipe = await session.call(op(
		'pickaxe.Withdraw',
		itemIds[discountPercent],
		chrClientAddr
	))
	console.log('pickaxe.Withdraw: ', recipe);
} */

export const WithdrawReq = async (
	period: number,
) => {
	const { discountPercent } = store.getState().app;
	const { session, chrClientAddr } = store.getState().chromia;

	if (!session || !chrClientAddr) throw new Error('');

	try {
		const tx = session.call(op(
			'pickaxe.WithdrawReq',
			Buffer.from(itemIds[discountPercent], 'hex'),
			Buffer.from(chrClientAddr, 'hex'),
			period
		))

		store.dispatch({
			type: eModalsActionTypes.OPEN_NEW_MODAL,
			payload: {
				name: 'transaction',
				transactionParams: {
					blockchain: 'chromia',
					transaction: tx,
				}
			}
		})

		console.log('tx: ', tx);
		const recipe = await tx;
		console.log('pickaxe.WithdrawReq: ', recipe);
	} catch (err) {
		logErrorKas(err as any);
		throw err;
	}
}

export const setPickaxeTime = async (
	time: number,	// ts
) => {
	const { session } = store.getState().chromia;

	if (!session) throw new Error('');

	const recipe = await session.call(op(
		'pickaxe.SetTime',
		time
	))
	console.log('pickaxe.SetTime: ', recipe);
}
export const setHedgetTime = async (
	time: number,	// ts
) => {
	const { session } = store.getState().chromia;

	if (!session) throw new Error('');

	const recipe = await session.call(op(
		'hedget.SetTime',
		time
	))
	console.log('hedget.SetTime: ', recipe);
}
export const setSlurpyswapTime = async (
	time: number,	// ts
) => {
	const { session } = store.getState().chromia;

	if (!session) throw new Error('');

	const recipe = await session.call(op(
		'slurpyswap.SetTime',
		time
	))
	console.log('slurpyswap.SetTime: ', recipe);
}

export const getFTokenBalance = async () => {
	const {discountPercent} = store.getState().app;
	return getAssetBallanceQuery(fTokenIds[discountPercent]);
	// return getAssetBallancesQuery();
}